import axios from "axios";
import React, { useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import Select from "react-select";

import { customSelectStyle } from "../../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle";
import { INSTALLLMENTS } from "./constants";
import { PlanFormWarnings } from '../../AddPlans/Steps/PlanFormWarnings';

export default function Step1(props) {
  const [isLoading,setIsLoading] = useState(true);
  const [featureGroups,setFeatureGroups] = useState({});
  const [displayAmount, setDisplayAmount] = useState("");
  const [displayOldAmount, setDisplayOldAmount] = useState("");

  const loadFeatureGroups = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/feature_groups?page_size=999999`
    );
    let featureGroups = response.data.data.data;
    setFeatureGroups(featureGroups);
    setIsLoading(false);
  };

  useEffect(() => {
    loadFeatureGroups();
  }, []);
    
  const formatToCurrency = (value) => {
    const number = Number.parseFloat(value);
    return number.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  const handleAmountChange = (e) => {
    let { value } = e.target;
    setDisplayAmount(value);
  };

  const handleOldAmountChange = (e) => {
    let { value } = e.target;
    setDisplayOldAmount(value);
  };

  const handleAmountBlur = () => {
    let numericValue = displayAmount.replace(/[^\d,]/g, "").replace(",", ".");
    numericValue = parseFloat(numericValue) || 0;
    
    const formattedValue = formatToCurrency(numericValue);
    
    setDisplayAmount(formattedValue);
    props.formik.setFieldValue("amount", numericValue);
  };

  const handleOldAmountBlur = () => {
    let numericValue = displayOldAmount.replace(/[^\d,]/g, "").replace(",", ".");
    numericValue = parseFloat(numericValue) || 0;
    
    const formattedValue = formatToCurrency(numericValue);
    
    setDisplayOldAmount(formattedValue);
    props.formik.setFieldValue("old_amount", numericValue);
  };

  useEffect(() => {
    if (!isNaN(props.formik.values.amount)) {
      const formattedValue = formatToCurrency(props.formik.values.amount);
      setDisplayAmount(formattedValue);
    }
  }, [props.formik.values.amount]);

  useEffect(() => {
    if (!isNaN(props.formik.values.old_amount)) {
      const formattedValue = formatToCurrency(props.formik.values.old_amount);
      setDisplayOldAmount(formattedValue);
    }
  }, [props.formik.values.old_amount]);

  return (
    <BlockUi tag="div" blocking={props.formik.isSubmitting}>
      <div className="row no-gutters mb-20">
        <div className="col-xl-12">
          <div
            className="border-radius-only-left"
            style={{ backgroundColor: "#fff", padding: "40px", height: "100%" }}
          >
            <PlanFormWarnings planId={props.id} formik={props.formik} />
            <div className="row mb-5">
              <div className="col-xl-6">
                <label className="form-label">
                  Nome <span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="text"
                  name="description"
                  className={
                    "form-control " +
                    (props.formik.errors.description && props.formik.touched.description
                      ? "is-invalid"
                      : "")
                  }
                  value={props.formik.values.description}
                  onChange={props.formik.handleChange}
                />
                {props.formik.errors.description && props.formik.touched.description && (
                  <label className="invalid-feedback">
                    {props.formik.errors.description}
                  </label>
                )}
              </div>
              <div className="col-xl-6">
                <label className="form-label">
                  Duração (em dias)<span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="number"
                  name="periodicity"
                  className={
                    "form-control " +
                    (props.formik.errors.periodicity && props.formik.touched.periodicity
                      ? "is-invalid"
                      : "")
                  }
                  value={props.formik.values.periodicity}
                  onChange={props.formik.handleChange}
                />
                {props.formik.errors.periodicity &&
                props.formik.touched.periodicity && (
                  <label className="invalid-feedback">
                    {props.formik.errors.periodicity}
                  </label>
                )}
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-xl-6">
                <label className="form-label">
                    Valor do plano <span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="text"
                  name="amount"
                  disabled={Boolean(props.id)}
                  className={
                    "form-control " +
                    (props.formik.errors.amount && props.formik.touched.amount
                      ? "is-invalid"
                      : "")
                  }
                  value={displayAmount}
                  onChange={handleAmountChange}
                  onBlur={handleAmountBlur}
                />
                {props.formik.errors.amount && props.formik.touched.amount && (
                  <label className="invalid-feedback">
                    {props.formik.errors.amount}
                  </label>
                )}
              </div>
              <div className="col-xl-6">
                <label className="form-label">
                    Valor do plano sem desconto <span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="text"
                  name="old_amount"
                  className={
                    "form-control " +
                    (props.formik.errors.old_amount && props.formik.touched.old_amount
                      ? "is-invalid"
                      : "")
                  }
                  value={displayOldAmount}
                  onChange={handleOldAmountChange}
                  onBlur={handleOldAmountBlur}
                />
                {props.formik.errors.old_amount && props.formik.touched.old_amount && (
                  <label className="invalid-feedback">
                    {props.formik.errors.old_amount}
                  </label>
                )}
              </div>
            </div>
            
            <div className="row mb-5">
              <div className="col-xl-6">
                <label className="form-label">
                  Código do Cupom <span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="text"
                  name="coupom"
                  className={
                    "form-control " +
                    (props.formik.errors.coupom && props.formik.touched.coupom
                      ? "is-invalid"
                      : "")
                  }
                  value={props.formik.values.coupom}
                  onChange={props.formik.handleChange}
                />
                {props.formik.errors.coupom && props.formik.touched.coupom && (
                  <label className="invalid-feedback">
                    {props.formik.errors.coupom}
                  </label>
                )}
              </div>
              <div className="col-xl-6">
                <label className="form-label">
                  Parcelas <span class="text-danger">&nbsp;*</span>
                </label>
                <Select
                  name="installments"
                  isSearchable={true}
                  isClearable={true}
                  options={INSTALLLMENTS}
                  className={
                    props.formik.errors.installments &&
                    props.formik.touched.installments
                      ? "is-invalid"
                      : ""
                  }
                  onChange={option => {
                    props.formik.setFieldValue("installments", option ? option.value : "");
                  }}
                  value={INSTALLLMENTS.find(option => option.value === props.formik.values.installments||"")}
                  placeholder="Selecione.."
                  getOptionLabel={option => option.label}
                  getOptionValue={option => option.value}
                  theme={customSelectStyle}
                />
                {props.formik.errors.installments &&
                  props.formik.touched.installments && (
                  <label className="invalid-feedback">
                    {props.formik.errors.installments}
                  </label>
                )}
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-xl-6">
                <label className="form-label">
                    Validade do Cupom <span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="date"
                  name="valid_until"
                  className={
                    "form-control " +
                      (props.formik.errors.valid_until && props.formik.touched.valid_until
                        ? "is-invalid"
                        : "")
                  }
                  value={props.formik.values.valid_until}
                  onChange={props.formik.handleChange}
                />
                {props.formik.errors.valid_until && props.formik.touched.valid_until && (
                  <label className="invalid-feedback">
                    {props.formik.errors.valid_until}
                  </label>
                )}
              </div>
              <div className="col-xl-6">
                <label className="form-label">
                  Máximo de resgates
                </label>
                <input
                  type="number"
                  name="max_redeems"
                  className={
                    "form-control " +
                    (props.formik.errors.max_redeems && props.formik.touched.max_redeems
                      ? "is-invalid"
                      : "")
                  }
                  value={props.formik.values.max_redeems}
                  onChange={props.formik.handleChange}
                />
                {props.formik.errors.max_redeems && props.formik.touched.max_redeems && (
                  <label className="invalid-feedback">
                    {props.formik.errors.max_redeems}
                  </label>
                )}
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-xl-6">
                <label className="form-label">
                    Dias de Trial<span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="number"
                  name="trial_days"
                  className={
                    "form-control " +
                      (props.formik.errors.trial_days && props.formik.touched.trial_days
                        ? "is-invalid"
                        : "")
                  }
                  value={props.formik.values.trial_days}
                  onChange={props.formik.handleChange}
                />
                {props.formik.errors.trial_days && props.formik.touched.trial_days && (
                  <label className="invalid-feedback">
                    {props.formik.errors.trial_days}
                  </label>
                )}
              </div>

              <div className="col-xl-6">
                <label className="form-label">
                  Grupo de planos <span class="text-danger">&nbsp;*</span>
                </label>
                {!isLoading? <Select
                  name="feature_group_id"
                  isSearchable={true}
                  isClearable={true}
                  options={featureGroups}
                  className={
                    props.formik.errors.feature_group_id &&
                    props.formik.touched.feature_group_id
                      ? "is-invalid"
                      : ""
                  }
                  onChange={option => {
                    props.formik.setFieldValue("feature_group_id", option.id);
                  }}
                  value={featureGroups.find(option => option.id === props.formik.values.feature_group_id)}
                  placeholder="Selecione.."
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  theme={customSelectStyle}
                />:null}
                {props.formik.errors.feature_group_id &&
                  props.formik.touched.feature_group_id && (
                  <label className="invalid-feedback">
                    {props.formik.errors.feature_group_id}
                  </label>
                )}
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-xl-6">
                <label className="form-label">
                  Requisitar cartão no checkout?<span className="text-danger">&nbsp;*</span>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="upfront_credit_card_required"
                    id="upfront_payment_yes"
                    onChange={() => props.formik.setFieldValue("upfront_credit_card_required", true)}
                    checked={props.formik.values.upfront_credit_card_required === true}
                  />
                  <label className="form-check-label" htmlFor="upfront_payment_yes">
                    Sim
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="upfront_credit_card_required"
                    id="upfront_payment_no"
                    onChange={() => props.formik.setFieldValue("upfront_credit_card_required", false)}
                    checked={props.formik.values.upfront_credit_card_required === false}
                  />
                  <label className="form-check-label" htmlFor="upfront_payment_no">
                    Não
                  </label>
                </div>
                {props.formik.errors.upfront_credit_card_required && props.formik.touched.upfront_credit_card_required && (
                  <div className="invalid-feedback d-block">
                    {props.formik.errors.upfront_credit_card_required}
                  </div>
                )}
              </div>
            </div>

            <div className="row mb-5">
              <div className="col-xl-12">
                <label className="form-label">
                  Descrição<span class="text-danger">&nbsp;*</span>
                </label>
                <textarea
                  name="subtitle"
                  className={
                    "form-control " +
                    (props.formik.errors.subtitle && props.formik.touched.subtitle
                      ? "is-invalid"
                      : "")
                  }
                  value={props.formik.values.subtitle}
                  onChange={props.formik.handleChange}
                  rows={3}
                ></textarea>
                {props.formik.errors.subtitle && props.formik.touched.subtitle && (
                  <label className="invalid-feedback">
                    {props.formik.errors.subtitle}
                  </label>
                )}
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-xl-12">
                <button
                  type="button"
                  onClick={props.formik.handleSubmit}
                  className="btn btn-primary"
                  style={{ width: "100%", height: "50px" }}
                >
                  SALVAR CUPOM
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BlockUi>
  );
}
